export const PARLOR_FAMILY_MAIN_PATH = "prlr_fam_main";
